import React from 'react';
import classNames from 'classnames';
import LayoutActions from '../../../../../reducers/layoutRedux';
import { useDispatch, useSelector } from 'react-redux';
import { getIcon } from '../../../../../utils/IconUtil';
import { CompletedStates } from '../../../../../utils/WorkflowTasks';

const TaxYearNavTab = (props) => {

    const dispatch = useDispatch();
    const selectedTaxYear = useSelector(state => state.layout.taxYearTab);

    const onTabChange = () => {
        dispatch(LayoutActions.setTaxYearTab(props.taxState.taxYear));
    }
    const isReturnFiled = props.taxState && CompletedStates.includes(props.taxState.ticketState);
    const isSelected = props.taxState.taxYear == selectedTaxYear;
    return (
        <div className={classNames('taxyearbar-navtab', props.layout, { 'taxyearbar-navtab navtab-selected' : isSelected }, { 'taxyearbar-navtab navtab-inprogress' : !isReturnFiled }, {'taxyearbar-navtab navtab-complete' : isReturnFiled})} onClick={onTabChange}>
            <div className='taxyearbar-navtab-label'>
                {props.taxState.taxYear}
            </div>
            { !isReturnFiled && <img src={getIcon('action-required')} /> }
        </div>
    );
} 

export default TaxYearNavTab;